export default {
    init() {
        const stickyHeaderUpdate = this.stickyHeader('.header')

        stickyHeaderUpdate()
        $(window).on('scroll', stickyHeaderUpdate)

        this.navItems()

        this.alertBar()
    },

    stickyHeader(item) {
        const header = $(item)
        const trigger = 120
        let sticky = false

        return function update() {
            if (window.scrollY > trigger) {
                if (!sticky) {
                    header.addClass('header--sticky')
                    sticky = true
                }
            } else {
                if (sticky) {
                    header.removeClass('header--sticky')
                    sticky = false
                }
            }
        }
    },

    alertBar() {
        $('.alert-bar button').click(function () {
            $('.alert-bar').addClass('hidden')
        })
    },

    navItems() {
        const navitem = $('[data-nav-link]')

        $(navitem).each(function () {
            const item = this
            const bg = $(item).find('[data-nav-link-line]')
            const timing = 0.65
            let hovered = false
            let animatingHover = false
            let forceOut = false

            $(item).mouseenter(() => {
                hoverInAnim()
            })

            function hoverInAnim() {
                if (!hovered) {
                    hovered = true
                    animatingHover = true
                    forceOut = false

                    $(item).css('color', '#ffffff')

                    TweenMax.fromTo(
                        bg,
                        timing,
                        { x: '-104%' },
                        {
                            x: '0%',
                            ease: Power3.easeOut,
                            onComplete: () => {
                                animatingHover = false
                                if (forceOut) {
                                    forceOut = false
                                    hoverOutAnim()
                                }
                            },
                        },
                    )
                }
            }

            $(item).mouseleave(() => {
                if (!animatingHover) {
                    hoverOutAnim()
                } else {
                    forceOut = true
                }
            })

            function hoverOutAnim() {
                hovered = false

                $(item).css('color', '')

                TweenMax.to(bg, timing, {
                    x: '104%',
                    ease: Power3.easeOut,
                    onComplete: () => {},
                })
            }
        })
    },
}
